import { Eeocs } from 'src/queries'

type TData = Eeocs[0]

const getDocumentData = (name: string): (data: TData) => string | null => {
  return (data) => {
    const { documentData } = data
    if (documentData === null || documentData === undefined) {
      return null
    }
    if (Array.isArray(documentData)) {
      const results = documentData.find((item) => item.name === name)
      return results?.value ?? null
    }
    return null
  }
}

export { getDocumentData }
